module.exports = __webpack_public_path__ + "static/media/IMG_4289.141b6ff1.PNG";